var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ThickChart"},[_c('span',{staticClass:"ThickChart__thick",style:(_vm.thickStyle)}),_c('span',{staticClass:"ThickChart__thin",style:(_vm.thinStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }